module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "grey"
  }, [_c('div', {
    staticClass: "x100"
  }, [_c('img', {
    staticClass: "i300",
    attrs: {
      "alt": "background",
      "src": "image/GettyImages-12716382743.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_section-number-white",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("5")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v(" section 1")]), _vm._v(" "), _c('div', {
    staticClass: "x100"
  }, [_c('img', {
    staticClass: "i300",
    attrs: {
      "alt": "pentagram",
      "src": "image/2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "section-title-white"
  }, [_vm._v("the basics of a "), _c('br'), _vm._v("group practice")]), _vm._v(" "), _c('div', {
    staticClass: "x100"
  }, [_c('img', {
    staticClass: "i300",
    attrs: {
      "alt": "background",
      "src": "image/GettyImages-1271638274.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e20d3ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EWC-1.vue
// module id = 72
// module chunks = 0